import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import prometheusClient from './prometheusClient';
const defaultOptions = {
  courseId: 'other',
  environment: 'LOCAL',
  incrementStep: 1
};
export const useMeasureDiscreteEvent = (eventName, options) => {
  const finalOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  const {
    courseId,
    environment,
    incrementStep,
    message
  } = finalOptions;
  // instantiate prometheus
  const prometheus = useMemo(() => prometheusClient(environment), [environment]);
  const [count, setCount] = useState(0);
  const increment = useCallback(() => {
    setCount(prevCount => prevCount + incrementStep);
  }, [incrementStep]);
  useEffect(() => {
    if (!prometheus || count <= 0) {
      return;
    }
    prometheus.increment(eventName, {
      appName: 'campus-app',
      courseId,
      environment,
      message
    }, incrementStep);
  }, [count, prometheus, eventName, environment, courseId, incrementStep, message]);
  return {
    increment
  };
};